import { render, staticRenderFns } from "./HandoutButton.vue?vue&type=template&id=28e2ff59&scoped=true&"
import script from "./HandoutButton.vue?vue&type=script&lang=js&"
export * from "./HandoutButton.vue?vue&type=script&lang=js&"
import style0 from "./HandoutButton.vue?vue&type=style&index=0&id=28e2ff59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2ff59",
  null
  
)

export default component.exports